import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
@Component({
  selector: 'app-favourite-list',
  templateUrl: './favourite-list.component.html',
  styleUrls: ['./favourite-list.component.css']
})
export class FavouriteListComponent {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.getPropertyList();
  }
  async getPropertyList() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FAVOURITE_PROPERTY_LIST, {
      limit: this.limit,
      offset: this.offset
    });
    if (res && !res.error && res.data) {
      this.propertyList = [];
      for(let t of res.data.rows) {
        if(t.FavouritePropertyToPropertyData) {
          this.propertyList.push(t.FavouritePropertyToPropertyData);
        }
      }
    }
  }
}
